import React from 'react';
import { useBusinessRules } from '@common/components/Business/rules';
import { BusinessName as InnerField } from '@common/components/BusinessForm/components/BusinessName';
import { FieldWrapper } from '../FieldWrapper';

export default function BusinessName() {
  const { businessNameRules } = useBusinessRules();
  return (
    <FieldWrapper<string>
      name="name"
      rules={businessNameRules}
      render={(props) => <InnerField {...props} />}
    />
  );
}
